import { productCardCarousels } from '~js/utils/product-card-swiper';
import { postAddToCart } from '~js/utils/variant';
import { QuickAddProductDrawer } from './card-drawer';

const productCard = {
  collectionContainer: null,
  productImageSwiper: null,
  productColorSwiper: null,
  isMobileCarouselDisabled: null,

  initialiseEvents(container) {
    this.initialiseElements(container);
    this.initialiseImageCarousels();
    this.initializeColorSwatchCarousels();
    this.addEventListenersToAllCards();
  },

  initialiseElements(container) {
    this.collectionContainer = document.querySelector(container);
    if (!this.collectionContainer) {
      console.error('Collection container not found');
      return;
    }
    this.isMobileCarouselDisabled = this.collectionContainer.getAttribute(
      'is-mobile-carousel-disabled',
    );
    if (this.isMobileCarouselDisabled == 'true')
      this.isMobileCarouselDisabled = true;
  },

  // Initialize the product image carousel for each individual card
  initialiseImageCarousel(card) {
    const imageSwiperContainer = card.querySelector(
      '.js-product-card-swiper-container',
    );
    if (!imageSwiperContainer) return;
    if (card.productImageSwiper) {
      card.productImageSwiper?.destroy(true, true);
    }
    card.productImageSwiper = productCardCarousels(
      imageSwiperContainer,
      1,
      1,
      0,
      card.querySelector('.js-product-card-swiper-next'),
      card.querySelector('.js-product-card-swiper-prev'),
      card.querySelector('.js-product-card-swiper-scrollbar'),
      this.isMobileCarouselDisabled,
    );
  },

  // Initialize image carousels for all product cards
  initialiseImageCarousels() {
    const productCards =
      this.collectionContainer.querySelectorAll('.js-product-card');
    productCards.forEach((card) => {
      this.initialiseImageCarousel(card);
    });
  },

  // Initialize the product color carousel for each individual card
  initializeColorSwatchCarousel(card) {
    const colorSwatchContainer = card.querySelector(
      '.js-product-card-color-swatch-swiper-container',
    );
    if (!colorSwatchContainer) return;
    if (card.productColorSwiper) {
      card.productColorSwiper?.destroy(true, true);
    }
    card.productColorSwiper = productCardCarousels(
      colorSwatchContainer,
      10,
      4.5,
      8,
      card.querySelector('.js-product-card-color-swatch-thumbnail-next'),
      card.querySelector('.js-product-card-color-swatch-thumbnail-prev'),
      false,
    );
  },

  // Initialize color swatches for all product cards
  initializeColorSwatchCarousels() {
    const productCards =
      this.collectionContainer.querySelectorAll('.js-product-card');
    productCards.forEach((card) => {
      this.initializeColorSwatchCarousel(card);
    });
  },

  addEventListenersToAllCards() {
    const productCards =
      this.collectionContainer?.querySelectorAll('.js-product-card');
    productCards.forEach((card) => {
      this.updateImgaeToColorSwatch(card);
      const addToBagButton = card.querySelector('.js-add-to-bag-cta');
      if (addToBagButton) {
        addToBagButton.addEventListener('click', () => {
          this.handleQuickAdd(card);
        });
      }
    });
  },

  async handleQuickAdd(card) {
    const cardCta = card.querySelector('.js-add-to-bag-cta');
    const handle = cardCta?.dataset?.handle;
    const ctaText = cardCta.querySelector('.js-add-to-bag-text');
    const ctaLoader = cardCta.querySelector('.js-quick-buy-cta-loader');
    const variantCount = cardCta?.dataset?.variantcount;

    if (!handle || !variantCount) return;
    cardCta.classList.add('is-adding');
    ctaText.classList.add('is-adding');
    ctaLoader.classList.add('is-adding');

    try {
      if (variantCount == 1) {
        const available = cardCta?.dataset?.available;
        const id = cardCta?.dataset?.id;

        if (!available) {
          alert('Product Sold Out!');
          ctaText.classList.toggle('hidden', false);
          ctaLoader.classList.toggle('hidden', true);
          return;
        }
        await postAddToCart(id);
      } else {
        if (
          this.collectionContainer?.dataset?.drawer === 'side_drawer' &&
          window.innerWidth > 750
        ) {
          window.QuickBuy.trigger(handle);
        } else {
          QuickAddProductDrawer.trigger(handle, card);
        }
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    } finally {
      cardCta.classList.remove('is-adding');
      ctaText.classList.remove('is-adding');
      ctaLoader.classList.remove('is-adding');
    }
  },

  updateImgaeToColorSwatch(card) {
    card
      .querySelectorAll('.js-quick-add-product-option-group-value')
      .forEach((input) => {
        input.addEventListener('change', (e) => {
          const selectedColor = e.target.getAttribute('data-color');
          const matchingSlideIndex = Array.from(
            card.querySelectorAll('.js-product-card-swiper-item'),
          ).findIndex((slide) =>
            slide.getAttribute('data-color').includes(selectedColor),
          );
          if (card.productImageSwiper && matchingSlideIndex !== -1) {
            card.productImageSwiper.slideTo(matchingSlideIndex, 500);
          }
        });
      });
  },
};

export default productCard;
